import { BatchMark } from "../../core/render/BatchMark";
export class InstanceBatchManager {
    constructor() {
        this._instanceBatchOpaqueMarks = [];
        this.updateCountMark = 0;
    }
    _getData(key, data, cls) {
        if (null == cls) {
            cls = Array;
        }
        if ("boolean" == typeof key) {
            return (data[key ? 0 : 1]) || (data[key ? 0 : 1] = new cls());
        }
        else {
            return data[key] || (data[key] = new cls());
        }
    }
    getInstanceBatchOpaquaMark(element) {
        let invertFrontFace = element._transform ? element._transform._isFrontFaceInvert : false;
        let receiveShadow = element._baseRender._receiveShadow;
        let matID_geometry = (element._material._id << 17) + (element._geometry._id << 2) + (Number(invertFrontFace) << 1) + Number(receiveShadow);
        let reflectid = (element._baseRender._probReflection ? element._baseRender._probReflection._reflectionProbeID : -1) + 1;
        let lightmapid = (element._baseRender.lightmapIndex) + 1;
        let lightprobid = (element._baseRender._lightProb ? element._baseRender._lightProb._volumetricProbeID : -1) + 1;
        let giID = (reflectid << 10) + (lightmapid << 20) + lightprobid;
        var data = this._getData(matID_geometry, this._instanceBatchOpaqueMarks);
        return this._getData(giID, data, BatchMark);
    }
}
InstanceBatchManager.instance = new InstanceBatchManager();
